/* ============
 * Payment Method Transformer
 * ============
 *
 * The transformer for the paymentMethods.
 */

import Transformer from './transformer';

export default class paymentMethodTransformer extends Transformer {

  static fetch(paymentMethod) {
    return {
      id: paymentMethod.id,
      name: paymentMethod.name,
      type: paymentMethod.type,
    };
  }

  static send(paymentMethod) {
    return {
      id: paymentMethod.id,
      name: paymentMethod.name,
      type: paymentMethod.type,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/paymentMethod.js